export const PREMIUM_ENABLED = String(process.env.REACT_APP_PREMIUM_ENABLED || '').toLowerCase() === 'true';
export const PREMIUM_ADMIN = String(process.env.REACT_APP_PREMIUM_ADMIN || '').toLowerCase() === 'true';
// Default-on unless explicitly disabled (env "false") so native builds don't
// accidentally turn this off when env vars are missing.
const dqFlagRaw = String(process.env.REACT_APP_DAILY_QUESTION_CANONICAL_SHARE || '').toLowerCase();
export const DAILY_QUESTION_CANONICAL_SHARE = dqFlagRaw !== 'false';

const featureFlags = {
  PREMIUM_ENABLED,
  PREMIUM_ADMIN,
  DAILY_QUESTION_CANONICAL_SHARE,
};

export default featureFlags;
